"use client";

import styles from "./Button.module.css";

const Button = (props) => {
  const classNames =
    styles["buttonClass"] +
    " " +
    props.classes
      ?.split(" ")
      .map((className) => styles[className] + " " + className)
      .join(" ");
  return (
    <span>
      <button
        className={[classNames, props.buttonBoxButtonClass].join(" ")}
        style={props.inlineStyles}
        value={props.value}
        onClick={props.handleClick}
        onSubmit={props.handleSubmit}
        disabled={props.disabled}
        type={props?.type}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
      >
        {props.text}
      </button>
    </span>
  );
};

export default Button;
